import { motion } from 'framer-motion';
import { personalData } from '../data/content';
import solarImg from '../assets/solar-panels.jpg';

export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3]">
              <img 
                src={solarImg} 
                alt="Solar Panels and Sustainability" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-emerald-900/10 mix-blend-overlay" />
            </div>
            {/* Decorative Element */}
            <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-emerald-100 rounded-full -z-10" />
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-gray-100 rounded-full -z-10" />
          </motion.div>

          {/* Text Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
              About Me
            </h2>
            <div className="space-y-4 text-lg text-gray-600 leading-relaxed">
              {personalData.bio.map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            
            <div className="mt-8 pt-8 border-t border-gray-100">
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Education</h3>
              <p className="text-gray-600">
                <span className="font-medium text-emerald-700">{personalData.education.degree}</span>
                <span className="mx-2">•</span>
                {personalData.education.school}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
